module.exports = __webpack_public_path__ + "img/ClosePopup.ef569523.svg";